(function () {
    // 注册组件
    SR.component.extend('toast', toast);
    
    function toast() {
        var $toast = $('<div class="sr-toast"></div>');
        var disappearTimer;
        SR.dom.$body.append($toast);

        this.show = function(options) {
            var msg = options.msg;
            var delay = options.delay || 2000;

            if (!msg || !msg.length) {
                return;
            }
            
            $toast.text(msg);
            var toastW = $toast.width() + 30;
            var toastH = $toast.height();
            $toast.css({
                "margin-top": (toastH / 2 * -1),
                "margin-left": (toastW / 2 * -1) 
            }).fadeIn();

            if (disappearTimer) {
                clearTimeout(disappearTimer);
                disappearTimer = null;
            }
            disappearTimer = setTimeout(function () {
                $toast.fadeOut();
            }, delay);
        }
    }
}());